export const COMMENTS_SET = 'COMMENTS_SET';
export const COMMENTS_UPDATE = 'COMMENTS_UPDATE';
export const COMMENT_DELETE = 'COMMENT_DELETE';
export const COMMENT_UPDATE = 'COMMENT_UPDATE';

export const COMMENT_EDITABLE_SET = 'COMMENT_EDITABLE_SET';


